import { render } from "./InfoItem.vue?vue&type=template&id=697e17fe&scoped=true&ts=true"
import script from "./InfoItem.vue?vue&type=script&lang=ts"
export * from "./InfoItem.vue?vue&type=script&lang=ts"

import "./InfoItem.vue?vue&type=style&index=0&id=697e17fe&scoped=true&lang=css"

import exportComponent from "/home/runner/work/mlp/mlp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-697e17fe"]])

export default __exports__